import React from 'react';

export default function LostConnection() {
    
    return(
        <div className="page lostConnection">
            <h1 className="lostConnection__Heading">Uh Oh You Lost Connection</h1>
        </div>
    )
}